import axios from "axios"
import { instanceConfig } from "../config"

export const apiInstanceV1 = axios.create({
    ...instanceConfig,
    baseURL: `/api`
})
